import Const from 'constants';
import {BaseAction} from 'actions';

const CorrelationStackedTeams = {
    setExposureMaxForCombo(params) {
        return {
            type: Const.CORRELATION_STACKING_COMBO_SET_EXPOSURE_MAX,
            params,
        };
    },
};

export default {...BaseAction, ...CorrelationStackedTeams};
